import React from 'react';
import { Rules } from '../../containers/Partners/Rules';
import { Groups } from '../../containers/Partners/Groups';
import { Levels } from '../../containers/Partners/Levels';
import classes from './Partners.module.scss';
import { PageTabs } from '../../containers/PageTabs';
import { Exceptions } from '../../containers/Partners/Exceptions';

export const Partners = () => {
  const availableTabs = [
    {
      key: '1',
      name: 'Rules',
      element: <Rules />,
    },
    {
      key: '2',
      name: 'Groups',
      element: <Groups />,
    },
    {
      key: '3',
      name: 'Levels',
      element: <Levels />,
    },
    {
      key: '4',
      name: 'Exceptions',
      element: <Exceptions />,
    },
  ];

  return (
    <div className={classes.root}>
      <h1 data-testid="partners">Partners</h1>
      <PageTabs tabs={availableTabs} />
    </div>
  );
};
